import React from "react";
import { Grid, InputAdornment, TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import PropTypes from "prop-types";
import { useEffect } from "react";
import useDebounce from "../../../libs/hooks/useDebounce";

function escapeRegExp(value) {
  return value.toString().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

export default function SearchData(props) {
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 500);

  const data = props.name;

  useEffect(() => {
    if (debouncedSearchText.length === 0) {
      props.onsetData(data);
    } else {
      const searchRegex = new RegExp(escapeRegExp(debouncedSearchText), "i");
      const result = data.filter((row) => {
        return Object.keys(row).some((field) => {
          return searchRegex.test(row[field]);
        });
      });

      props.onsetData(result);
    }
  }, [debouncedSearchText]);

  const onSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <Grid container sx={{ justifyContent: "end" }} alignItems="center">
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          disableUnderline: true,
        }}
        // onChange={(e) => requestSearch(e.target.value)}
        style={{ textAlign: "center" }}
        size="small"
        variant="filled"
        hiddenLabel
        placeholder="Search"
        type="search"
        onChange={onSearchChange}
      />
    </Grid>
  );
}
SearchData.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
